import script from "./PersonalInfoStep3Content.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep3Content.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep3Content.vue?vue&type=style&index=0&id=6535d794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6535d794"]])

export default __exports__